import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.sass'],
})
export class InputComponent implements OnInit {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  @Input()
  typeCes?: TypeCesEnum | undefined;
  @Input()
  isMultipleSelect?: boolean ;
  @Output()
  onSelect: EventEmitter<any> = new EventEmitter();
  @Input()
  maxLength?: number;

  @Output()
  onBlur: EventEmitter<any> = new EventEmitter();

  @Output()
  onChange: EventEmitter<any> = new EventEmitter();

  @Output()
  selectionChange: EventEmitter<any> = new EventEmitter();

  @Output()
  onClick: EventEmitter<any> = new EventEmitter();
  
  // Eventos para manipulação de arquivos
  @Output()
  onFileClick: EventEmitter<any> = new EventEmitter();
  
  @Output()
  onFileDelete: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  get typeComponentFieldEnum() {
    return TypeComponentFieldEnum;
  }
}
